import { Tag } from 'antd';
import { SuggestionStatus } from '../../types';

const statusMap: Record<SuggestionStatus, { color: string; text: string }> = {
  [SuggestionStatus.SUBMITTED]: {
    color: 'default',
    text: 'Suggestion Pending',
  },
  [SuggestionStatus.REVIEWED]: {
    color: 'success',
    text: 'Suggestion Accepted',
  },
  [SuggestionStatus.REJECTED]: { color: 'error', text: 'Suggestion Rejected' },
  [SuggestionStatus.NONE]: {
    color: 'default',
    text: 'None',
  },
  [SuggestionStatus.APPROVED]: {
    color: 'success',
    text: 'Suggestion Accepted',
  },
};

const SuggestionTag = ({ status }: { status: SuggestionStatus }) => {
  const { color, text } = statusMap[status];
  return text === 'None' ? null : (
    <div>
      <Tag color={color} bordered={false}>
        {text}
      </Tag>
    </div>
  );
};

export default SuggestionTag;
